import { render, staticRenderFns } from "./SalesDialog.vue?vue&type=template&id=79c96d58&scoped=true&"
import script from "./SalesDialog.vue?vue&type=script&lang=js&"
export * from "./SalesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c96d58",
  null
  
)

export default component.exports